export const toFormattedAmountByLocale = (
  amount: string,
  locale: any = (window as any).currentLocale,
  optionalDecimal: boolean = false,
): string => {
  const { decimalSeparator } = locale
  const thousands_separator = locale.thousandsSeparator
  const formatNumber = (n) =>
    // format number 1000000 to 1,234,567
    n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, thousands_separator)

  const parts = (amount ?? '').split('.')
  const decimalPart = parts[1] ?? '00'
  const formattedDecimalPart =
    decimalPart == '00' && optionalDecimal ? '' : `${decimalSeparator}${decimalPart}`
  return `${formatNumber(parts[0])}${formattedDecimalPart}`
}
